/**
 * lg-bundle-selector.js
 * Maps a canonical product page selection to the correct child product variant.
 */
(function () {
  'use strict';

  function initBundleSelector(root) {
    if (!root || root._lgBundleSelectorBound) return;
    root._lgBundleSelectorBound = true;

    var sectionId = root.dataset.sectionId;
    if (!sectionId) return;

    var form = document.getElementById('product-form-' + sectionId);
    if (!form) return;

    var buyButtons = form.closest('.lg-buy-buttons');
    var productFormEl = form.closest('product-form');

    var variantIdInput = form.querySelector('.product-variant-id');
    var configInput = form.querySelector('[data-bundle-config-input]');
    var childHandleInput = form.querySelector('[data-bundle-child-handle]');
    var childProductIdInput = form.querySelector('[data-bundle-child-product-id]');
    var submitButton = form.querySelector('#ProductSubmitButton-' + sectionId);
    var submitButtonText = submitButton ? submitButton.querySelector('span') : null;
    var installmentInput = document.querySelector('#product-form-installment-' + sectionId + ' input[name="id"]');
    var priceTarget = document.getElementById('price-' + sectionId);
    var inventoryTarget = document.getElementById('Inventory-' + sectionId);
    var includesTarget = root.querySelector('[data-bundle-includes-target]');
    var configTarget = root.querySelector('[data-bundle-config-target]');
    var qtyWidget = buyButtons.querySelector('[data-lg-quantity][data-section-id="' + sectionId + '"]');
    var qtyValue = qtyWidget ? qtyWidget.querySelector('[data-qty-val]') : null;
    var qtyInput = form.querySelector('[data-lg-quantity-input]');
    var options = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-option]'));

    function getTemplate(attributeName, productId) {
      return root.querySelector('[' + attributeName + '="' + productId + '"]');
    }

    function copyTemplate(template, target) {
      if (!target) return;
      target.innerHTML = template ? template.innerHTML : '';
    }

    function setSubmitState(available, hasVariant) {
      if (!submitButton || !submitButtonText) return;

      if (available && hasVariant) {
        submitButton.removeAttribute('disabled');
        submitButton.removeAttribute('aria-disabled');
        submitButtonText.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
        return;
      }

      submitButton.setAttribute('disabled', 'disabled');
      submitButton.setAttribute('aria-disabled', 'true');
      submitButtonText.textContent =
        hasVariant
          ? ((window.variantStrings && window.variantStrings.soldOut) || 'Sold out')
          : ((window.variantStrings && window.variantStrings.unavailable) || 'Unavailable');
    }

    function setQtyState(maxQty) {
      if (!qtyWidget || !qtyValue || !qtyInput) return;

      var nextMax = parseInt(maxQty, 10);
      if (!nextMax || nextMax < 1) {
        qtyWidget.dataset.maxQty = '';
        qtyValue.textContent = '1';
        qtyInput.value = '1';
        qtyWidget.querySelectorAll('[data-qty-action]').forEach(function (btn) {
          btn.disabled = false;
        });
        return;
      }

      qtyWidget.dataset.maxQty = String(nextMax);
      var currentQty = parseInt(qtyValue.textContent, 10) || 1;
      var clampedQty = Math.min(currentQty, nextMax);
      qtyValue.textContent = String(clampedQty);
      qtyInput.value = String(clampedQty);

      qtyWidget.querySelectorAll('[data-qty-action]').forEach(function (btn) {
        if (btn.dataset.qtyAction === 'plus') {
          btn.disabled = clampedQty >= nextMax;
        } else if (btn.dataset.qtyAction === 'minus') {
          btn.disabled = clampedQty <= 1;
        }
      });
    }

    function updateSelection(option) {
      if (!option) return;

      var bundleKind = option.dataset.bundleKind || 'child';
      var productId = option.dataset.bundleProductId;
      var variantId = option.dataset.bundleVariantId || '';
      var label = option.dataset.bundleLabel || '';
      var available = option.dataset.bundleAvailable === 'true';
      var maxQty = option.dataset.bundleMaxQty || '';

      options.forEach(function (entry) {
        var isActive = entry === option;
        entry.classList.toggle('is-active', isActive);
        entry.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (variantIdInput) {
        variantIdInput.value = variantId;
        variantIdInput.disabled = !(available && variantId);
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (installmentInput) {
        installmentInput.value = variantId;
        installmentInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (configInput) configInput.value = label;
      if (childHandleInput) childHandleInput.value = bundleKind === 'child' ? (option.dataset.bundleProductHandle || '') : '';
      if (childProductIdInput) childProductIdInput.value = bundleKind === 'child' ? (productId || '') : '';
      if (configTarget) configTarget.textContent = label;

      copyTemplate(getTemplate('data-bundle-price-template', productId), priceTarget);
      copyTemplate(getTemplate('data-bundle-inventory-template', productId), inventoryTarget);
      copyTemplate(getTemplate('data-bundle-includes-template', productId), includesTarget);

      setQtyState(maxQty);
      setSubmitState(available, !!variantId);

      document.dispatchEvent(new CustomEvent('lg:bundle-selection-change', {
        detail: {
          sectionId: sectionId,
          parentProductId: root.dataset.parentProductId || '',
          selectedProductId: productId || '',
          selectedVariantId: variantId || '',
          selectedLabel: label,
          bundleKind: bundleKind,
          available: available,
        }
      }));
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        updateSelection(option);
      });
    });

    updateSelection(root.querySelector('[data-bundle-option].is-active') || options[0]);
  }

  function initAllBundleSelectors() {
    document.querySelectorAll('[data-bundle-selector]').forEach(initBundleSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBundleSelectors);
  } else {
    initAllBundleSelectors();
  }

  document.addEventListener('product-info:loaded', initAllBundleSelectors);
  document.addEventListener('shopify:section:load', initAllBundleSelectors);
})();
